/**
 * Created by PanJiaChen on 16/11/18.
 */

export function getCurrentDateTime() {
  const date = new Date()

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      const userAgent = navigator.userAgent
      // 判断是否Safari浏览器
      if (userAgent.indexOf('Safari') > -1) {
        time = time.replace(/\-/g, '/') // 把'-'转成'/' yyyy/mm/dd
      }
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  } else if (diff < 3600 * 24 * 3) {
    return '2天前'
  } else if (diff < 3600 * 24 * 4) {
    return '3天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日'
      // +
      // d.getHours() +
      // '时' +
      // d.getMinutes() +
      // '分'
    )
  }
}

/**
 * 获取当前月份天数
 * @returns {Number}
 */
export function getMonthDate() {
  const curDate = new Date()
  /* 获取当前月份 */
  const curMonth = curDate.getMonth()
  curDate.setDate(1)
  curDate.setMonth(curMonth + 1)
  curDate.setDate(0)
  /* 返回当月的天数 */
  return curDate.getDate()
}

/**
 * 获取今天多少号
 * @returns {Number}
 */
export function getDate() {
  const curDate = new Date()
  return curDate.getDate()
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * 深拷贝
 * 这个函数有个小问题，一般情况不会遇到，如果遇到请查看：
 * https://stackoverflow.com/a/4460624
 * @param {mixed} item
 * @returns {Object}
 */
export function deepClone(item) {
  if (!item) { return item } // null, undefined values check

  var types = [Number, String, Boolean]
  var result

  // normalizing primitives if someone did new String('aaa'), or new Number('444');
  types.forEach(function(type) {
    if (item instanceof type) {
      result = type(item)
    }
  })

  if (typeof result === 'undefined') {
    if (Object.prototype.toString.call(item) === '[object Array]') {
      result = []
      item.forEach(function(child, index, array) {
        result[index] = deepClone(child)
      })
    } else if (typeof item === 'object') {
      // testing that this is DOM
      if (item.nodeType && typeof item.cloneNode === 'function') {
        result = item.cloneNode(true)
      } else if (!item.prototype) { // check that this is a literal
        if (item instanceof Date) {
          result = new Date(item)
        } else {
          // it is an object literal
          result = {}
          for (var i in item) {
            result[i] = deepClone(item[i])
          }
        }
      } else {
        // depending what you would like here,
        // just keep the reference, or create new object
        // eslint-disable-next-line
        if (false && item.constructor) {
        } else {
          result = item
        }
      }
    } else {
      result = item
    }
  }

  return result
}

/**
 * 人类可读的数量大小
 * @param {mixed} item
 * @returns {Object}
 */
export function humanNumber(num) {
  if (num >= 10000) {
    num = Math.round(num / 10000 * 100) / 100 + 'W'
  } else if (num >= 1000) {
    num = Math.round(num / 1000 * 100) / 100 + 'K'
  }
  return num
}

/**
 * 人类可读的字节大小
 * @param {mixed} item
 * @returns {Object}
 */
export function humanSize(bytes, decimals = 2) {
  if (bytes === 0) return '0 B'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

/**
 * 环比
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} 两位小数
 */
export function mathDiv(x, y) {
  x = Number(x)
  y = Number(y)
  const z = y === 0 ? 0.00 : Number((x / y).toFixed(2))
  return z
}

/**
 * 环比
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} 两位小数
 */
export function mathRate(x, y) {
  x = Number(x)
  y = Number(y)
  const z = y === 0 ? 0.00 : Number(((x / y) * 100).toFixed(2))
  return z
}

/**
 * 环比
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} 两位小数
 */
export function mathCircle(x, y) {
  x = Number(x)
  y = Number(y)
  const z = y === 0 ? 0.00 : Number((((x / y) - 1) * 100).toFixed(2))
  return z
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function queryString(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
  })).join('&')
}

/**
 *  小数点取2位小数，整数或中文不处理
 * @param {any} obj 需要转换的值
 * @return {Number} 转换完成的值
 */
export function toFixed(data, number = 2, percentType) {
  if (data) {
    let obj = data ? data.toString() : data
    if (obj.toString().includes('%') && percentType) {
      obj = obj.replace('%', '')
    }

    if (isNaN(obj / 1)) {
      return obj // 处理中文
    }
    if (obj % 1 !== 0) {
      // 不是正数加.00
      obj = Number(obj)
      obj = (parseInt(obj * 10000) / 10000).toFixed(number) // 防止四舍五入
    }
    if (Number(obj) === parseInt(obj) && obj.toString().indexOf('.') > 0) {
      // 处理 小数点后面都是0的情况
      obj = parseInt(obj)
    }

    if (data && data.toString().includes('%') && percentType) {
      return obj.toString() + '%'
    } else {
      return obj
    }
  } else {
    return data
  }
}

/**
 *  把 % 号转换成数字
 * @param {any} data 需要转换的值
 * @return {Number} 转换完成的值
 */
export function toPoint(data) {
  const percent = data ? data.toString() : data // 不是字符串不能使用indexOf与replace
  if (percent && percent.indexOf('%')) {
    let str = percent.replace('%', '')
    if (!isNaN(str)) { // 确保是数字
      if (str === 'Infinity') {
        return 0
      } else {
        str /= 100
        return str
      }
    } else {
      return str === 'NaN' ? 0 : percent
    }
  } else {
    return percent
  }
}
/**
 * 获取某月1号到月尾最后一天
 * @param {Date | undefined} timestamps 需要计算的格林威治时间 不传为当月
 * @param {Number | undefined} type 转换的类型 不传则按默认处理
 * @param {Number} AddMonthCount 往后+几个月
 * @return [某月第一天，某月最后一天]
 */
export function getMonthStartAndEnd(timestamps, type, AddMonthCount = 0) {
  const startStop = []
  let currentDate = ''
  // 获取当前时间
  if (timestamps) {
    const day = new Date(timestamps).getDate()
    let count = 3
    if (day < 5) {
      count = 0
    }
    currentDate = new Date(timestamps - 24 * 60 * 60 * 1000 * count)
  } else {
    currentDate = new Date()
  }
  let month = currentDate.getMonth() + AddMonthCount
  if (month < 0) {
    const n = parseInt((-month) / 12)
    month += n * 12
    currentDate.setFullYear(currentDate.getFullYear() - n)
  }
  currentDate = new Date(new Date(currentDate.setDate(1)).setMonth(month))
  // 获得当前月份0-11
  const currentMonth = currentDate.getMonth()
  // 获得当前年份4位年
  const currentYear = currentDate.getFullYear()
  // 获得上一个月的第一天
  const currentMonthFirstDay = new Date(currentYear, currentMonth, 1)
  // 获得上一月的最后一天
  const currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0)
  // 添加至数组
  startStop.push(formatDate(currentMonthFirstDay, type))
  startStop.push(formatDate(currentMonthLastDay, type))
  // 返回
  return startStop
}

/**
 * 格式化时间戳
 * @param {Date} date 需要计算的时间
 * @param {Number | Null} type 转换的类型
 * @return {String} 格式化的时间
 */
export function formatDate(date, type) {
  const data = date
  const y = data.getFullYear()
  const m = data.getMonth() + 1 < 10 ? '0' + parseInt(data.getMonth() + 1) : data.getMonth() + 1
  const d = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()
  if (type === '.') {
    return m + '.' + d
  } else if (type === '/') {
    return y + '/' + m + '/' + d
  } else {
    return y + '-' + m + '-' + d
  }
}

/**
 * 获取纯数字动态单元格的宽度
 * @param {any} list 数据列表
 * @param {String} value 当前需要处理的key
 * @param {Number} num 微调值
 * @param {any} merge 合并列表，比较特殊 如分时数据表
 * @return {Number}
 */
export function getWidthOnly(list, value, num = 0, merge = false, label = '当前') {
  if (list.length > 0) {
    const dataList = merge ? list[0][0][value] : list[0][value]
    if (dataList) {
      // 第一行就是合计
      let width = 0

      if (dataList.toString().indexOf('%') > -1 && label.indexOf('当前') === -1) {
      // 百分号固定宽度
        width = 50
      } else {
        const data = dataList
        const px = 9
        if (data.toString().indexOf('.') > -1) {
        // 含小数点给两倍
          width = Number(data.toString().length * px) + px + num
        } else {
          width = data.toString().length > 3 ? Number(data.toString().length * px) + num : 50
        }
      }
      return width < 50 ? 50 : width
    }
  }
  return 50
}

/**
 * 固定配置维度宽度
 * @param {any} item 维度名称
 * @param {Number} index 维度下标
 * @return {Number} 单元格宽度
 */
export function getWidthDimensionColumn(item, index) {
  const widthGroup = {
    '日期': 75,
    '平台': 65,
    '游戏类型': 60,
    '根游戏': 95,
    '主游戏': 125,
    '负责人': 65,
    '渠道组': 70,
    '广告位ID': 115,
    '广告1级': 120,
    '广告2级': 115,
    '广告3级': 115,
    '系统': 68,
    '系统版本': 50,
    '手机型号': 70,
    '区服ID': 60,
    '注充间隔': 60,
    '模拟器': 60,
    '代理': 60,
    '创建方式': 50,
    '合同游戏名': 100
  }
  if (index === 0 && item === '日期' && !this.fullDaysColumnName) {
    return 85
  } if (item === '日期' && this.aggregationTime === '按周') {
    return 150
  } else if (Object.keys(widthGroup).indexOf(item) > -1 && item !== this.fullDaysColumnName) {
    return widthGroup[item]
  } else if (item === this.fullDaysColumnName) {
    return 114
  } else {
    return 150
  }
}

/**
 * 判断是否为空
 * @param {any} mixedVar
 * @return {boolean}
 */
export function empty(mixedVar) {
  //  discuss at: https://locutus.io/php/empty/
  // original by: Philippe Baumann
  //    input by: Onno Marsman (https://twitter.com/onnomarsman)
  //    input by: LH
  //    input by: Stoyan Kyosev (https://www.svest.org/)
  // bugfixed by: Kevin van Zonneveld (https://kvz.io)
  // improved by: Onno Marsman (https://twitter.com/onnomarsman)
  // improved by: Francesco
  // improved by: Marc Jansen
  // improved by: Rafał Kukawski (https://blog.kukawski.pl)
  //   example 1: empty(null)
  //   returns 1: true
  //   example 2: empty(undefined)
  //   returns 2: true
  //   example 3: empty([])
  //   returns 3: true
  //   example 4: empty({})
  //   returns 4: true
  //   example 5: empty({'aFunc' : function () { alert('humpty'); } })
  //   returns 5: false

  let undef
  const emptyValues = [undef, null, false, 0, '', '0']

  for (let i = 0, len = emptyValues.length; i < len; i++) {
    if (mixedVar === emptyValues[i]) {
      return true
    }
  }

  if (typeof mixedVar === 'object') {
    for (const key in mixedVar) {
      if (mixedVar.hasOwnProperty(key)) {
        return false
      }
    }
    return true
  }

  return false
}

/**
 * 获取两个时间差
 * @param {String} sDate 开始时间
 * @param {String} eDate 结束时间
 * @return {Number} 时间差
 */
export function dateDifference(sDate, eDate, none) {
  sDate = new Date(new Date(sDate).setHours(0, 0, 0, 0)).getTime()
  eDate = new Date(new Date(eDate).setHours(0, 0, 0, 0)).getTime()
  let dateSpan = eDate - sDate
  dateSpan = Math.abs(dateSpan)
  let iDays = 0
  if (none) {
    // 向上取整
    iDays = dateSpan / (24 * 3600 * 1000)
  } else {
    // 向下取整
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
  }
  return iDays
}

export function getDiffdate(stime, etime, month = false) {
  // 初始化日期列表，数组
  const diffdate = []
  let i = 0
  // 开始日期小于等于结束日期,并循环
  let date = stime
  while (stime <= etime) {
    if (month) {
      const data = date.split('-')
      diffdate[i] = data[0] + '-' + data[1]
    } else {
      diffdate[i] = date
    }

    // 获取开始日期时间戳
    const stimeTs = new Date(stime).getTime()
    // 增加一天时间戳后的日期
    const nextDate = stimeTs + (24 * 60 * 60 * 1000)

    // 拼接年月日，这里的月份会返回（0-11），所以要+1
    const nextDatesY = new Date(nextDate).getFullYear() + '-'
    const nextDatesM = (new Date(nextDate).getMonth() + 1 < 10) ? '0' + (new Date(nextDate).getMonth() + 1) + '-' : (new Date(nextDate).getMonth() + 1) + '-'
    const nextDatesD = (new Date(nextDate).getDate() < 10) ? '0' + new Date(nextDate).getDate() : new Date(nextDate).getDate()
    if (month) {
      date = nextDatesY + nextDatesM
    } else {
      date = nextDatesY + nextDatesM + nextDatesD
    }
    stime = nextDatesY + nextDatesM + nextDatesD

    // 增加数组key
    i++
  }
  return Array.from(new Set(diffdate))
}

/**
 * 获取当前使用设备的是否PC
 * @return {Boolean} true PC false Phone
 */
export function isPC() {
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    return false
  } else {
    return true
  }
}

export function p(s) {
  return s < 10 ? '0' + s : s
}

export function getWeekRang(datevalue) {
  const dateValue = datevalue
  const arr = dateValue.split('-')
  // 月份-1 因为月份从0开始 构造一个Date对象
  const date = new Date(arr[0], arr[1] - 1, arr[2])
  const dateOfWeek = date.getDay()// 返回当前日期的在当前周的某一天（0～6--周日到周一）
  let dateOfWeekInt = parseInt(dateOfWeek, 10)// 转换为整型
  if (dateOfWeekInt === 0) { // 如果是周日
    dateOfWeekInt = 7
  }
  const aa = 7 - dateOfWeekInt// 当前于周末相差的天数
  const temp2 = parseInt(arr[2], 10)// 按10进制转换，以免遇到08和09的时候转换成0
  const sunDay = temp2 + aa// 当前日期的周日的日期
  const monDay = sunDay - 6// 当前日期的周一的日期
  const startDate = new Date(arr[0], arr[1] - 1, monDay)
  const endDate = new Date(arr[0], arr[1] - 1, sunDay)
  const sm = parseInt(startDate.getMonth()) + 1// 月份+1 因为月份从0开始
  const em = parseInt(endDate.getMonth()) + 1
  //  alert("星期一的日期："+startDate.getFullYear()+"-"+sm+"-"+startDate.getDate());
  //  alert("星期日的日期："+endDate.getFullYear()+"-"+em+"-"+endDate.getDate());
  const start = startDate.getFullYear() + '-' + p(sm) + '-' + p(startDate.getDate())
  const end = endDate.getFullYear() + '-' + p(em) + '-' + p(endDate.getDate())
  const result = []
  result.push(start)
  result.push(end)

  return result
}
/**
 * 格式化岗位列表
 * @return {Array}
 */
export function formatPositionCascader(list) {
  const departmentEightList = list.department_eight_list.map(element => {
    element.value = element.platform_id + '-' + element.department_id + '-' + element.department_group_id + '-' + element.department_group_position_id + '-' + element.department_group_position_worker_id + '-' + element.department_six_id + '-' + element.department_seven_id + '-' + element.id
    element.label = element.name
    return element
  })

  const departmentSevenList = list.department_seven_list.map(element => {
    element.value = element.platform_id + '-' + element.department_id + '-' + element.department_group_id + '-' + element.department_group_position_id + '-' + element.department_group_position_worker_id + '-' + element.department_six_id + '-' + element.id
    element.label = element.name
    element.children = []
    for (const i in departmentEightList) {
      if (element.id === departmentEightList[i].department_seven_id) {
        element.children.push(departmentEightList[i])
      }
    }
    return element
  })

  const departmentSixList = list.department_six_list.map(element => {
    element.value = element.platform_id + '-' + element.department_id + '-' + element.department_group_id + '-' + element.department_group_position_id + '-' + element.department_group_position_worker_id + '-' + element.id
    element.label = element.name
    element.children = []
    for (const i in departmentSevenList) {
      if (element.id === departmentSevenList[i].department_six_id) {
        element.children.push(departmentSevenList[i])
      }
    }
    return element
  })

  const departmentGroupPositionWorkerList = list.department_group_position_worker_list.map(element => {
    element.value = element.platform_id + '-' + element.department_id + '-' + element.department_group_id + '-' + element.department_group_position_id + '-' + element.id
    element.label = element.name
    element.children = []
    for (const i in departmentSixList) {
      if (element.id === departmentSixList[i].department_group_position_worker_id) {
        element.children.push(departmentSixList[i])
      }
    }
    return element
  })

  const departmentGroupPositionList = list.department_group_position_list.map(element => {
    element.value = element.platform_id + '-' + element.department_id + '-' + element.department_group_id + '-' + element.id
    element.label = element.name
    element.children = []
    for (const i in departmentGroupPositionWorkerList) {
      if (element.id === departmentGroupPositionWorkerList[i].department_group_position_id) {
        element.children.push(departmentGroupPositionWorkerList[i])
      }
    }
    return element
  })

  const departmentGroupList = list.department_group_list.map(element => {
    element.value = element.platform_id + '-' + element.department_id + '-' + element.id
    element.label = element.name
    element.children = []
    for (const i in departmentGroupPositionList) {
      if (element.id === departmentGroupPositionList[i].department_group_id) {
        element.children.push(departmentGroupPositionList[i])
      }
    }
    return element
  })

  const departmentList = list.department_list.map(element => {
    element.value = element.platform_id + '-' + element.id
    element.label = element.name

    element.children = []
    for (const i in departmentGroupList) {
      if (element.id === departmentGroupList[i].department_id) {
        element.children.push(departmentGroupList[i])
      }
    }
    return element
  })

  const platformList = list.platform_list.map(element => {
    element.value = element.id.toString()
    element.label = element.name
    element.children = []
    for (const i in departmentList) {
      if (element.id === departmentList[i].platform_id) {
        element.children.push(departmentList[i])
      }
    }
    return element
  })

  return platformList
}

export function replace(data, targetValue, replaceValue) {
  if (data.lastIndexOf(targetValue) !== -1) {
    return data.substring(0, data.lastIndexOf(targetValue)) + replaceValue
  } else {
    return data
  }
}

export function stein(a, b) {
  if (a === 0) { return b }
  if (b === 0) { return a }
  var c = 0
  while (((a & 1) === 0) && ((b & 1) === 0)) {
    a = a >> 1
    b = b >> 1
    c = c + 1
  }
  while ((a & 1) === 0) {
    a = a >> 1
  }
  while ((b & 1) === 0) {
    b = b >> 1
  }
  if (a < b) {
    b = (b - a) >> 1
    return stein(b, a) << c
  } else {
    a = (a - b) >> 1
    return stein(a, b) << c
  }
}

export function formatSeconds(value, cFormat) {
  let secondTime = parseInt(value)// 秒
  let minuteTime = 0// 分
  let hourTime = 0// 小时
  if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60)
    // 获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60)
    // 如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      // 获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60)
      // 获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  if (secondTime < 10) {
    secondTime = '0' + secondTime
  }
  let result = '00:' + secondTime

  if (minuteTime >= 0) {
    const second = result.split(':')
    if (minuteTime < 10) {
      minuteTime = '0' + minuteTime
    }
    result = '00:' + minuteTime + ':' + second[second.length - 1]
  }

  if (hourTime >= 0) {
    const min = result.split(':')
    if (hourTime < 10) {
      hourTime = '0' + hourTime
    }
    result = '' + hourTime + ':' + min[min.length - 2] + ':' + min[min.length - 1]
  }
  if (cFormat) {
    const formatObj = {
      h: hourTime,
      i: minuteTime,
      s: secondTime
    }
    result = cFormat.replace(/{(h|i|s)+}/g, (result, key) => {
      const value = formatObj[key]
      return value || 0
    })
  }
  return result
}

export function exportTable(column, data, name, type) {
  // 导出文件：column表头数据{label,prop}, data表数据, 导出文件名称，文件格式（'.xls','.csv'）
  exportCsv(getTableData(column, data), name, type)
}

function exportCsv(data, name, type) {
  // \ufeff 解决中文乱码问题
  var blob = new Blob(['\ufeff', data], { type: 'text/plain' })
  const uri = window.URL.createObjectURL(blob)
  const downloadLink = document.createElement('a')
  downloadLink.href = uri
  downloadLink.download = (name + type) || 'temp' + type
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}

function getTableData(column, data) {
  let dataString = ''
  // 拼接表头
  const header = []
  column.forEach(element => {
    header.push(element.label)
  })
  dataString += header.join(',') + '\n'
  // 拼接数据
  data.forEach(element => {
    const body = []
    column.forEach(item => {
      const value = element[item.prop] ? element[item.prop].toString().replace(/\,/g, '、') : element[item.prop] === 0 || element[item.prop] ? element[item.prop] : ''
      if (Number.isInteger(Number(value))) {
        const num = value.toString().split('.')[0]
        if (num.length > 8) {
          body.push('="' + value + '"')
        } else {
          body.push(value)
        }
      } else {
        body.push(value)
      }
    })
    dataString += body.join(',') + '\n'
  })
  return dataString
}

export function setFormRule(message, trigger = 'change', type, validator, required = true) {
  const setValidator = (trigger = 'blur') => {
    const valid = [{ required: required, message: message, trigger: trigger }]
    const isNumber = /^[0-9]+$/
    if (type === 'number') {
      valid.push(
        { validator: (rule, value, callback) => {
          if (!required && !value) {
            callback()
          } else if (!isNumber.test(value)) {
            callback(new Error('请输入正整数值'))
          } else {
            callback()
          }
        }, trigger: trigger }
      )
    }
    if (type && type.indexOf('float') > -1) {
      const float = type.split('-')
      const number = float.length === 2 ? float[1] : 2
      valid.push(
        { validator: (rule, value, callback) => {
          const reg = new RegExp(`^\\d{0,}(\\.\\d{0,${number}})?$`, 'g')
          if (!required && !value) {
            callback()
          } else if (String(value).indexOf('.') === value.length - 1 || String(value).indexOf('.') === 0) { // . 或者 1. 的时候走进这个逻辑
            callback(new Error('数字不合法'))
          } else if (!reg.test(value)) {
            callback(new Error('小数点只能' + number + '位'))
          } else {
            callback()
          }
        }, trigger: trigger }
      )
    }
    if (validator) {
      valid.push({ validator: validator, trigger: trigger })
    }
    return valid
  }
  if (trigger instanceof Array) {
    return Array.from(new Set(trigger.map(data => setValidator(data)).reduce((acc, val) => acc.concat(val), [])))
  } else {
    return setValidator(trigger)
  }
}
/**
 * Parse the time to string
 * @param {number} len
 * @param {number} num
 * @returns {array}
 */
export function randomDiffNum(len, num) {
  const result = []
  const arr = []
  for (let i = 1; i <= len; i++) {
    arr.push(i)
  }
  for (let i = 0; i < num; i++) {
    // 向下舍入取随机整数，生成索引
    const r = Math.floor(Math.random() * arr.length)
    result.push(arr[r])
    // 删除该随机
    arr.splice(r, 1)
  }
  return result
}
/**
 * 将"YYYY 第WW周"格式转换为"YYYY-MM-DD"格式
 * @param weekString 形如"2025 第44周"的字符串
 * @returns 转换后的日期字符串，格式为"YYYY-MM-DD"，返回周一开始的日期
 */
export function weekToDate(weekString) {
  const match = weekString.match(/(\d{4})年第(\d{1,2})周/)
  if (!match) {
    throw new Error('输入格式不正确，请使用"YYYY年第WW周"格式')
  }

  const year = parseInt(match[1], 10)
  const week = parseInt(match[2], 10)

  // 创建日期对象，设置为当年的1月1日
  const date = new Date(year, 0, 1)

  // 计算1月1日是星期几（0-6，其中0是星期日）
  const dayOfWeek = date.getDay()

  // 计算1月1日所在周的周一（如果1月1日是周日，则周一为1月2日）
  // 注意：这里我们认为一周从周一开始
  let daysToFirstMonday = 0
  if (dayOfWeek === 0) {
    daysToFirstMonday = 1 // 如果是周日，加1天到周一
  } else {
    daysToFirstMonday = 8 - dayOfWeek // 否则计算到下周一的天数
  }

  // 设置日期为第一周的周一
  date.setDate(date.getDate() + daysToFirstMonday)

  // 根据输入的周数，设置日期
  // 注意：这里的week是从1开始的，所以需要减1再乘以7
  date.setDate(date.getDate() + (week - 1) * 7)

  // 格式化日期为YYYY-MM-DD格式
  const yearStr = date.getFullYear()
  const monthStr = String(date.getMonth() + 1).padStart(2, '0')
  const dayStr = String(date.getDate()).padStart(2, '0')

  return `${yearStr}-${monthStr}-${dayStr}`
}

/**
 * 防抖函数,只在事件停止触发后执行最后一次操作
 * @param {Function} func - 需要防抖的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @returns {Function} 防抖后的函数
 */
export function debounce(func, delay = 300) {
  let timer = null
  // 返回一个新的防抖函数
  return function(...args) {
    // 清除上一次定时器
    if (timer) clearTimeout(timer)
    // 重新设置定时器
    timer = setTimeout(() => {
      func.apply(this, args) // 绑定this并传递参数
    }, delay)
  }
}
